import Translation from './translation'

export default class Post extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    set Image(value){
        if(value != null){
            this.image = value
            this.picture = URL.createObjectURL(value)
        }else{
            this.image = null
            this.picture = this.image_url
        }
    }
    
    get ImageName(){
        var path = require('path');
        return this.image != null
            ? path.basename(this.image.value)
            : path.basename(this.image_url);
    }

    get ImageType(){
        return this.image != null
            ? this.image.type
            : this.ImageName.split('.').pop()
    }


    constructor(post){
        super()
        this.id             = 0
        
        this.locales        = []
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.content_ar     = ''
        this.content_en     = ''
        this.content_fa     = ''

        this.published      = false

        this.thumbnails     = {}
        this.image          = null
        this.get_image_url  = null
        this.image_url      = null
        this.picture        = null
        this.tags           = []

        this.editor_images  = []
        this.map(post)
        this.init()
    }

    map(post){
        if(post == undefined) return
        this.id             = post.id
        this.get_image_url  = post.get_image_url
        this.image_url      = post.image_url
        this.picture        = ''
        this.thumbnails     = post.thumbnails
        
        this.published      = post.published_at != null
        this.tags           = post.tags??[]
        this.created_at     = post.created_at  
        this.updated_at     = post.updated_at  
        this.published_at   = post.published_at  

        for (let locale in post.translations) {
            this['title_' + locale] = post.translations[locale].title
            this['content_' + locale] = post.translations[locale].content
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][content]', this['content_'+ locale]);
        }
        
        fData.append('published', Number(this.published));

        if(this.image != null){
            fData.append('image', this.image);
        }

        this.tags.forEach(tag=>fData.append('tags[]', tag))

        this.editor_images.forEach(img=>fData.append('editor_images[]', img.id))
        
        return fData
    }
}

